import { render, staticRenderFns } from "./MemberPackOrders.vue?vue&type=template&id=87918b54&scoped=true"
import script from "./MemberPackOrders.vue?vue&type=script&lang=js"
export * from "./MemberPackOrders.vue?vue&type=script&lang=js"
import style0 from "./MemberPackOrders.vue?vue&type=style&index=0&id=87918b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87918b54",
  null
  
)

export default component.exports